import React, { useEffect, useState } from "react";
import { useMemo } from "react";

import { Box, Button, Typography, Paper, Grid } from "@mui/material";
import "./Services.css";
import { useDispatch, useSelector } from "react-redux";
import { ShowVendorServices } from "../../../../context/Slice/ServiceManagementSlice";
import { ShowAllCategories } from "../../../../context/Slice/VendorManagementSlice";
import { useNavigate } from "react-router-dom";
import VendorServiceCards from "./VendorServiceCards";
import VendorServicesShowsDetails from "./VendorServicesShowsDetails";
import VendorServicesEditForm from "./VendorServicesEditForm";
import ImagePopup from "../../../../utils/imagePopup";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Serviceone = () => {
  const [vendorDetails, setVendorDetails] = useState(null);
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Define navigate inside the component
  const [selectedService, setSelectedService] = useState("");
  const [filteredVendorDetails, setFilteredVendorDetails] = useState([]); // Declare global state for filtered vendor details
  const [imagepath, setImagePath] = useState(""); // Declare global state for image path
  const [isViewmore, setIsViewMore] = useState(false);
  const [ShowCard, setShowCards] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [FilterByIds, setFilterByIds] = useState(0);
  const [selectedValues, setSelectedValues] = useState({});
  const [dynamicData, setDynamicData] = useState({});
  const [openVideo, setOpenVideo] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const categories = useSelector((state) => state.VendorManagementR.AllCat);

  useEffect(() => {
    // Dispatch the action to fetch all categories
    dispatch(ShowAllCategories());
  }, [dispatch]);

  // ShowVendorServices APi

  useEffect(() => {
    const vendorId = localStorage.getItem("userId");

    if (!vendorId) {
      console.error("No vendor ID found in localStorage");
      return;
    }

    dispatch(ShowVendorServices(vendorId))
      .unwrap()
      .then((data) => {
        // console.log("Vendor Services Data:", data.VendorServices);
        setVendorDetails(data.VendorServices);
      })
      .catch((error) => {
        console.error("Error fetching vendor services:", error);
      });
  }, [dispatch, isEditMode]);

  useEffect(() => {
    if (filteredVendorDetails.length > 0) {
      const filteredVendor = filteredVendorDetails[0];

      setSelectedValues((prev) => {
        if (Object.keys(prev).length === 0) {
          return {
            ...filteredVendor,
            SpecialBadges: filteredVendor.SpecialBadges
              ? JSON.parse(filteredVendor.SpecialBadges)
              : [], // Ensure SpecialBadges is always an array
          };
        }
        return prev;
      });
    }
  }, [filteredVendorDetails]);

  useEffect(() => {
    if (selectedService) {
      const filteredDetails = vendorDetails?.filter(
        (vendor) => vendor.ServiceName === selectedService
      );
      if (filteredDetails && filteredDetails.length > 0) {
        setFilteredVendorDetails(filteredDetails);
        setImagePath(filteredDetails[0].image); // Set the imagepath when filtered details are updated
      }
    }
  }, [selectedService, vendorDetails]); // Trigger this effect when selectedService or vendorDetails changes

  const handleVideoClick = (videoUrl) => {
    if (!videoUrl || typeof videoUrl !== "string") {
      console.error("Invalid video URL");
      return;
    }

    setSelectedVideo(videoUrl); // Set the selected video URL
    setOpenVideo(true); // Open the dialog
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setOpenImage(true);
  };

  // const handleCloseImage = () => {
  //   setOpenImage(false);
  //   setSelectedImage(null);
  // };

  const HandleBackToDashborad = () => {
    navigate("/vendor-dashboard");
  };

  const HandleBackToCards = () => {
    setShowCards(true);
    setIsViewMore(false);
    setIsEditMode(false);
  };
  const HandleBackToViewDetail = () => {
    setIsViewMore(true);
    setShowCards(false);
    setIsEditMode(false);
  };
  const handleEditOpen = () => {
    setIsEditMode(true);
  };

  console.log(selectedValues);

  // Only run when filteredVendor changes
  const vendorForm = useMemo(() => {
    // console.log("Data", filteredVendorDetails);
    const filteredVendor = filteredVendorDetails[0];
    // console.log("filteredVendor:", filteredVendor);
    // console.log(selectedValues)
    if (filteredVendor) {
      const serviceCategoryID = selectedValues.ServiceCategory_ID;
      // console.log("ServiceCategory_ID:", serviceCategoryID);

      const filteredCategory = categories.find(
        (cat) => cat.id === serviceCategoryID
      );
      // console.log("filteredCategory:", filteredCategory);

      if (filteredCategory) {
        let categorieFields;
        try {
          categorieFields = JSON.parse(filteredCategory.CategorieFields);
        } catch (error) {
          console.error("Error parsing CategorieFields:", error);
          categorieFields = []; // Fallback to an empty array if parsing fails
        }

        console.log(selectedValues)

        return (
          <>
            <VendorServicesEditForm
              filteredVendor={filteredVendor}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              FilterByIds={FilterByIds}
              vendorDetails={vendorDetails}
              setIsEditMode={setIsEditMode}
              handleImageClick={handleImageClick}
              handleVideoClick={handleVideoClick}
              categorieFields={categorieFields}
            />
          </>
        );
      } else {
        console.log("No matching category found for this vendor.");
        return null;
      }
    }

    console.log("Dependencies updated:", {
      filteredVendorDetails,
      categories,
      selectedValues,
    });
  }, [filteredVendorDetails, categories, selectedValues, dynamicData]);

  return (
    <Box sx={{ padding: "20px", position: "relative" }}>
      {/* Back Button */}
      <Button
        variant="contained"
        color="secondary"
        onClick={
          ShowCard
            ? HandleBackToDashborad
            : isEditMode
            ? HandleBackToViewDetail
            : HandleBackToCards
        }
        sx={{
          position: "absolute",
          top: "10px",
          left: "10px",
          zIndex: 2,
        }}
      >
        Back
      </Button>
      (
      {ShowCard && (
        <>
          <VendorServiceCards
            vendorDetails={vendorDetails}
            handleImageClick={handleImageClick}
            setSelectedService={setSelectedService}
            setFilterByIds={setFilterByIds}
            HandleBackToViewDetail={HandleBackToViewDetail}
          />
        </>
      )}
      {isViewmore && (
        <Box
          sx={{
            display: { xs: "flex", sm: "flex", md: "flex" },
            flexDirection: { xs: "column", sm: "column", md: "column" },
            textAlign: "center",
            maxWidth: "800px",
            margin: "auto",
            position: "relative",
          }}
        >
          {vendorDetails ? (
            <>
              {isViewmore && selectedService && (
                <Paper
                  className="ServiceoneEdit-div"
                  elevation={3}
                  sx={{
                    // padding: "30px",
                    borderRadius: "12px",
                    textAlign: "left",
                    maxWidth: "800px",
                    // margin: "0 auto",
                  }}
                >
                  {/* Owner Image */}
                  <Box
                    className="OwnerImage"
                    sx={{ marginLeft: "32px", textAlign: "center" }}
                  >
                    {vendorDetails
                      .filter(
                        (service) => service.ServiceName === selectedService
                      )
                      .map((service, index) => {
                        console.log(`Service ${index + 1}:`, service);

                        return (
                          <Grid item xs={3} key={index}>
                            {service.BannerImage &&
                            service.BannerImage.length > 0 ? (
                              (() => {
                                try {
                                  // console.log("Raw BannerImage:", service.BannerImage);

                                  // Ensure BannerImage is an array
                                  const bannerImages = Array.isArray(
                                    service.BannerImage
                                  )
                                    ? service.BannerImage
                                    : JSON.parse(service.BannerImage || "[]"); // Prevent JSON parse errors

                                  // console.log("Parsed BannerImage:", bannerImages);

                                  return bannerImages.map((img, imgIndex) => {
                                    const imagePath = `${BASE_URL}/${img.path
                                      .replace(
                                        "/home/ubuntu/new/CEP_BackEnd/",
                                        ""
                                      )
                                      .replace(
                                        "/home/CEP_BackEnd/",
                                        ""
                                      )}`.replace(/([^:])\/\//g, "$1/"); // Prevent double slashes
                                    // Fixes missing slashes

                                    // console.log(`Banner Image ${imgIndex + 1} path:`, imagePath);

                                    return (
                                      <img
                                        key={imgIndex}
                                        src={imagePath}
                                        alt={`OwnerImage ${imgIndex + 1}`}
                                        style={{
                                          width: "60%",
                                          height: "300px",
                                          objectFit: "cover",
                                          cursor: "pointer",
                                          borderRadius: "8px",
                                        }}
                                        onClick={() =>
                                          handleImageClick(imagePath)
                                        }
                                      />
                                    );
                                  });
                                } catch (error) {
                                  console.error(
                                    "Error parsing BannerImage:",
                                    error
                                  );
                                  return (
                                    <p className="error-message">
                                      Invalid Banner Image Data
                                    </p>
                                  );
                                }
                              })()
                            ) : (
                              <img
                                src="/assets/Images/weddingdir-slider-2.jpg" // Default image path
                                alt="DefaultImage"
                                style={{
                                  width: "60%",
                                  height: "300px",
                                  objectFit: "cover",
                                  cursor: "pointer",
                                  borderRadius: "8px",
                                }}
                                onClick={() =>
                                  handleImageClick(
                                    "/assets/Images/weddingdir-slider-2.jpg"
                                  )
                                }
                              />
                            )}
                          </Grid>
                        );
                      })}
                  </Box>
                  {/* Service one page Vendor Information  */}

                  {isEditMode ? (
                    <div
                      id="Serviceone-Edit"
                      style={{
                        padding: "20px",
                        fontFamily: "Arial, sans-serif",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      <h1
                        style={{
                          textAlign: "center",
                          color: "#333",
                          marginBottom: "20px",
                        }}
                      >
                        Edit Vendor Details
                      </h1>
                      {vendorForm}
                    </div>
                  ) : (
                    <>
                      <VendorServicesShowsDetails
                        vendorDetails={vendorDetails}
                        FilterByIds={FilterByIds}
                        handleImageClick={handleImageClick}
                      />
                    </>
                  )}

                  {!isEditMode && (
                    <Button
                      sx={{
                        backgroundColor: "#007bff", // Green background
                        color: "#fff", // White text
                        padding: "10px 20px", // Padding for button
                        borderRadius: "5px", // Rounded corners
                        border: "none", // No border
                        cursor: "pointer", // Pointer cursor on hover
                        fontWeight: "bold", // Bold text
                        transition: "background-color 0.3s ease", // Smooth transition for background color on hover
                        "&:hover": {
                          backgroundColor: "#007bff", // Darker green on hover
                        },
                      }}
                      onClick={handleEditOpen} // Toggle edit mode when clicked
                    >
                      Edit
                    </Button>
                  )}
                </Paper>
              )}

              {/* Image Popup */}
              <ImagePopup
                selectedImage={selectedImage}
                onClose={() => setSelectedImage(null)}
              />
            </>
          ) : (
            <Typography
              variant="body1"
              align="center"
              sx={{ fontSize: "1.2rem" }}
            >
              Loading...
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Serviceone;
